module.exports = __webpack_public_path__ + "static/media/Pomeranian-Regular.b9e6b3af.ttf";